// Just fetches the totals, no auth needed, no point using the query package
import axios from "axios";

export const fetchTotals = () =>
  axios
    .get(`${process.env.REACT_APP_API_SERVER_URL}api/totals`)
    .then((res) => res.data);
